<template lang="html">
<div class="preferences-special">
  <div v-if="error" class="error">
    {{ error.message ? error.message : $t('common.errrorLoadingPageContent') }}
  </div>
  <div v-else-if="loading">
    loading . . .
  </div>
  <div v-else>
    <ModalConfirm
      :open="showSFVacancySelectConfirm" 
      :textBody="showSFVacancyConfirmationText"
      @closeCofirm="selectSFVacancyConfirmYes"
      @closeCancel="selectSFVacancyConfirmNo"
    />
    <div class="row-block">
      <div>
        <label>{{ $t('vacancy.preferences.special.SFId') }}</label>

        <multiselect
          :value="sfVacancy"
          @input="sfVacancyChange"
          :options="vacanciesList"
          open-direction="bottom"
          label="titleFull"
          track-by="sapVacancyId"
          :placeholder="$t('vacancy.preferences.special.SFSelectVacancy')"
          :searchable="true"
          :allow-empty="true"
          :show-labels="true"
        />
      </div>
      <div class="help">
        <span>{{ $t('vacancy.preferences.special.SFIdHelper') }}</span>
      </div>
    </div>
    <div class="button-wrapper">
      <vbutton label="common.save" @click="save"/>
    </div>
  </div>
</div>
</template>

<script>
import ModalConfirm from '@/components/modals/ModalConfirm.vue'

/**
 * convert item from storage to item which is used in dropdown
 */
function convertItemForDropdown (item) {
  if (!item) {
    return null
  }

  return {
    sapVacancyId: item.sap_vacancy_id,
    titleFull: [item.sap_vacancy_id, item.title].join(' ')
  }
}
export default {
  name: 'process-vacancy-preferences-special',

  components: {
    ModalConfirm
  },

  data () {
    return {
      selectedSFVacancyBeforeConfirm: null,
      showSFVacancySelectConfirm: false,
      showSFVacancyConfirmationText: '',
      SFVacancyBindedToVcvVacancyID: null
    }
  },

  computed: {
    vacancy () {
      return this.$store.getters['vacancy/one']
    },
    storeList () {
      return this.$store.state.process.deloitteSF.vacancy.SFVacanciesList
    },

    storeSingle () {
      return this.$store.state.process.deloitteSF.vacancy.SFVacancy
    },

    loading () {
      return this.storeList.loading || this.storeSingle.loading
    },

    error () {
      return this.storeList.error || this.storeSingle.error
    },

    vacanciesList () {
      return this.storeList.data.map(convertItemForDropdown)
    },

    sfVacancy () {
      if (!this.storeSingle.item) {
        return null
      }

      const storageItem = this.storeSingle.item

      return this.vacanciesList.find(
        el => el.sapVacancyId === storageItem.sap_vacancy_id
      )
    }
  },

  methods: {
    sfVacancyChange (value) {
      const needConfirmation = this.needConfirmation(value)
      if (needConfirmation) {
        this.selectedSFVacancyBeforeConfirm = value
        this.showSFVacancyConfirmationText = this.$t(
          'vacancy.preferences.special.SFVacancyIsAlreadyBeenAssigned',
          [this.SFVacancyBindedToVcvVacancyID]
        )
        this.showSFVacancySelectConfirm = true
      } else {
        this.change(value)
      }
    },

    change (item) {
      if (!item) {
        this.$store.dispatch('process/deloitteSF/vacancy/SFVacancy/update', null)
        return
      }

      const storageItem = Object.assign(
        {},
        this.storeList.data.find(
          el => el.sap_vacancy_id === item.sapVacancyId
        )
      )
      storageItem.vacancy_id = this.vacancy ? this.vacancy.id : null
      this.$store.dispatch('process/deloitteSF/vacancy/SFVacancy/update', storageItem)
    },

   /**
    * Check if newly selected value need confirmation before has been selected
    */
    needConfirmation (value) {
      this.SFVacancyBindedToVcvVacancyID = null
      if (!value) {
        return false
      }

      const storageItem = this.storeList.data.find(
        el => el.sap_vacancy_id === value.sapVacancyId
      )

      if (!storageItem) {
        return false
      }

      if (storageItem.vacancy_id && Number(storageItem.vacancy_id) !== Number(this.vacancy.id)) {
        this.SFVacancyBindedToVcvVacancyID = storageItem.vacancy_id
      }

      return Boolean(this.SFVacancyBindedToVcvVacancyID)
    },

    selectSFVacancyConfirmYes () {
      this.change(this.selectedSFVacancyBeforeConfirm)
      this.showSFVacancySelectConfirm = false
      this.showSFVacancyConfirmationText = ''
    },

    selectSFVacancyConfirmNo () {
      this.selectedSFVacancyBeforeConfirm = null
      this.showSFVacancySelectConfirm = false
      this.showSFVacancyConfirmationText = ''
    },
    save() {
      this.$store.dispatch('process/deloitteSF/vacancy/SFVacancy/save')
    }
  },

  mounted () {
    // add event listener for common save button click
    // double $parent, because of use of proxy component: Component where event occur -> Special (proxy) -> SpecialProcess (our)
    // this.$parent.$parent.$on('saveOnParent', () => {
    //  this.$store.dispatch('process/deloitteSF/vacancy/SFVacancy/save')
    // })
  },

  destroyed () {
    // Handler is not removed, because we must save changed data even after leaving special process tab
    // this.$parent.$off('saveOnParent')
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../styles/colors.scss";

  .preferences-special {
    margin-top: 30px;
    margin-bottom: 30px;

    .row-block {
      display: flex;
      margin: 40px 0 40px 0;
      align-items: flex-start;
      justify-content: space-between;
      max-width: 1000px;

      & > div:first-child {
        width: calc(60% - 40px);
        margin-right: 40px;
      }

      div.help {
        padding-top: 28px;
        width: 40%;

        span {
          display: block;
          padding: 10px 15px;
          border-radius: 5px;
          background-color: $line-statuses-status-settings-bg;
        }
      }

      label {
        font-size: 16px;
        display: block;
        margin-bottom: 10px;
      }

      input {
        max-width: 200px;
        min-height: 26px;
        font-size: 16px;
      }
    }
  }
</style>
